// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureLayout_root__QsY62","download":"ProcedureLayout_download__qNkmc","legalese":"ProcedureLayout_legalese__rR5Gx","legaleseCopy":"ProcedureLayout_legaleseCopy__yQHKu"};